module.exports = __webpack_public_path__ + "img/9.50f73452.jpg";